import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import ReducedData from '../reducedData.json';
import dict from '../dictionary';

class CasesByAgePie extends Component {
  constructor(props) {
    super(props);
    this.sortByAge = this.sortByAge.bind(this);
  }
  state = {
    ready: false,
    pieData: [{}],
    pieOptions: {},
  };

  componentDidMount() {
    this.sortByAge();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.sortByAge();
    }
  }

  sortByAge() {
    var cD = Object.values(ReducedData.dataAges);

    const reso = cD.map((item) => {
      return item[dict.resolved];
    });

    const active = cD.map((item) => {
      return item[dict.NotResolved];
    });

    const fatal = cD.map((item) => {
      return item[dict.deaths];
    });

    const total = [];

    for (let i = 0; i < fatal.length; i++) {
      total[i] = reso[i] + active[i] + fatal[i];
    }

    this.setState({
      pieData: total,

      pieOptions: {
        pie: {
          donut: {
            size: '65%',
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          width: 100,
          type: 'pie',
        },
        labels: [
          'Under 20',
          '20-29',
          '30-39',
          '40-49',
          '50-59',
          '60-69',
          '70-79',
          '80-89',
          '90-99',
          'Unknown',
        ],
        responsive: [
          {
            breakpoint: 200, // TODO find the actual good breakpoint
            options: {
              chart: {
                animations: {
                  enabled: false,
                  animateGradually: {
                    enabled: false,
                  },
                  dynamicAnimation: {
                    enabled: false,
                  },
                },
                width: 100,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        title: {
          text: '',
        },
        dataLabels: {
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, val.toFixed(1) + '%'];
          },
        },
        legend: {
          show: false,
        },
        fill: {
          colors: [
            '#00b0da',
            '#00b29c',
            '##00b454',
            '#84b449',
            '#ebb14a',
            '#ff9f49',
            '#ff8146',
            '#ff6947',
            '#ff6947',
          ],
        },
      },
    });

    this.setState({ ready: true });
  }

  render() {
    return (
      <div id="regional" className="chart">
        {this.state.ready ? (
          <>
            <ReactApexChart
              options={this.state.pieOptions}
              series={this.state.pieData}
              type="pie"
              height="400px"
            />

            {/* <p>
              {trans.casesByAge.noteA[this.props.lang]} {this.state.unk}{" "}
              {trans.casesByAge.noteB[this.props.lang]}
            </p> */}
          </>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default CasesByAgePie;
